import { styled } from '../../../../../modules';

export const StyledButton = styled.button<{
    $backgroundColor: string;
    $textColor: string;
    $disabled: boolean;
    $loading: boolean;
    $variant: 'filled' | 'soft';
}>`
    width: 100%;
    padding: 16px 8px;
    border: none;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 600;
    outline: none;
    transition: opacity 0.2s ease;
    cursor: ${({ $disabled, $loading }) => ($disabled || $loading ? 'not-allowed' : 'pointer')};
    opacity: ${({ $disabled, $loading }) => ($disabled || $loading ? 0.5 : 1)};
    background-color: ${({ $backgroundColor, $variant }) => $variant === 'soft' ? `${$backgroundColor}33` : $backgroundColor};
    color: ${({ $textColor, $variant, $backgroundColor }) => $variant === 'soft' ? $backgroundColor : $textColor};
`;
